define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/page/localeProvider",
	"csi/reflection",
	"csi/state/rootStore",
	"csi/table/NewFrom",
	"csi/xml",
	"SiteAdmin/BusinessObject",
	"SiteAdmin/ConfigurableAttributeMixin",
	"SiteAdmin/AttributeDefinition/AttributeDefinitionPopup",
	"SiteAdmin/AttributeDefinition/AttributeDefinitionStore",
], function(declare, locale, localeProvider, reflection, {routerStore}, NewFrom, xml, BusinessObject, ConfigurableAttributeMixin, AttributeDefinitionPopup, AttributeDefinitionStore) {

	return declare([NewFrom, ConfigurableAttributeMixin], {
		/** @property {boolean} useReactForm - use new React attribute form rather than Dojo form */
		useReactForm: false,

		/**
		 * @override
		 * Return all attributes created in dialog
		 * @return {C8Node[]}
		 */
		getNewNodes() {
			if (this.useReactForm) {
				return this.store.resultNodes;
			} else {
				return this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * There will always be a form for defining an attribute (React or Dojo)
		 */
		hasFormForEachSelection() {
			return true;
		},

		/**
		 * @override
		 * See if there are multiple target classes for this inherited attribute
		 */
		onValidate() {
			this.m_formData.getSelectedNodes().forEach((fromNode) => {
				const inheritedAttr = reflection.getAttributeByClassNameAndId(fromNode.ReflectionAttributeOwner, fromNode.ReflectionAttributeId);
				if (!inheritedAttr) { // attribute isn't in reflection yet - update config is needed first
					throw new Error(locale.resource("InheritedAttributeNotReady", [fromNode.ReflectionAttributeOwner + "." + fromNode.ReflectionAttributeId]));
				}
				const targetClasses = inheritedAttr.destinations;
				if (targetClasses.length > 1) { // ambiguous mapping - show a warning
					const targetClassList = targetClasses.map(tc => tc.type).join(",");
					throw new Error(locale.resource("AmbiguousTargetClass", [targetClassList, fromNode.ReflectionAttributeOwner + "." + fromNode.ReflectionAttributeId]));
				}
			});
		},

		toWriter() {
			var fd = this.m_formData;
			var nodeBO = fd.getSource().getParent();
			var id = fd.getFieldValue(xml.ATTR_NAME);
			var attURL = BusinessObject.getBOCustomAttributeURL(nodeBO.$Name, id);

			this.toWriterBase(attURL);
			var cn = this.m_writer.changeNode(attURL);

			this.applyBuildInAttributesCopyOption(fd, cn, fd.getSource().m_nodeSource);

			cn.changeAttributeFlag(reflection.ATTR_VALUETYPE, xml.ATTR_FLAGS_READONLY, true, false);
			cn.changeAttributeFlag(BusinessObject.ATTR_TARGET_CLASS_NAME, xml.ATTR_FLAGS_READONLY, true, false);
			return true;
		},

		/**
		 * @override
		 * Open React form if so configured
		 */
		_popupSourceForm(node) {
			const {m_cache, useReactForm} = this;

			if (useReactForm) {
				const store = this.store = new AttributeDefinitionStore.default(node, this.getParent(), m_cache, localeProvider);
				// if multiple sources were chosen, using defer allow previous instance of attribute form to close before opening next one
				_.defer(()=>{
					this.useReactDialog(routerStore.openDialog(AttributeDefinitionPopup.default, {
						onClose: () => {
							this.onCancelReactDialog();
						},
						onSave: () => {
							if (store.validate()) {
								this.processReact(store.saveForm((urlNode) => {
									this.m_value = [urlNode];
								}));
							}
						},
						title: this.getTitle(),
						store,
					}))
				});
			} else {
				this.inherited(arguments);
			}
		},

		_toWriterParent() { }
	});
});